module.exports = __webpack_public_path__ + "img/ukr_poshta.81adb3bc.png";